import { render, staticRenderFns } from "./ModattaStepInteractionInputUrl.vue?vue&type=template&id=089a6518"
import script from "./ModattaStepInteractionInputUrl.vue?vue&type=script&lang=js"
export * from "./ModattaStepInteractionInputUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports